// TODO(OL): Contact presentation that top-area should stop using css files
import { createStaticApp } from '@ori-appshell/rendering';
import '@ori/top-area/src/App.css';
import { APP_NAME } from '~/constants-generated';
export default createStaticApp({
    emotionCacheKey: APP_NAME,
    appName: APP_NAME
});
